class IPhone17DeviceShop extends HTMLElement {
  connectedCallback() {
    this.family = 'all';
    this.items = Array.from(this.querySelectorAll('[data-product-item]'));
    this.count = this.querySelector('[data-result-count]');
    this.empty = this.querySelector('[data-empty]');
    this.deviceLabel = this.dataset.deviceLabel || 'selected device';

    const requestedDeviceGroup = new URLSearchParams(window.location.search).get('device_group');
    const requestedDeviceTab = requestedDeviceGroup
      ? this.querySelector(`[data-device-selector-tab="${CSS.escape(requestedDeviceGroup)}"]`)
      : null;
    if (requestedDeviceTab) {
      this.selectDeviceGroup(requestedDeviceTab);
    }

    this.addEventListener('click', (event) => {
      const galaxyATab = event.target.closest('[data-galaxy-a-tab]');
      if (galaxyATab && this.contains(galaxyATab)) {
        const selectedGroup = galaxyATab.dataset.galaxyATab;
        this.querySelectorAll('[data-galaxy-a-tab]').forEach((candidate) => {
          candidate.setAttribute('aria-pressed', candidate === galaxyATab ? 'true' : 'false');
        });
        this.querySelectorAll('[data-galaxy-a-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.galaxyAPanel !== selectedGroup;
        });
        return;
      }

      const deviceSelectorTab = event.target.closest('[data-device-selector-tab]');
      if (deviceSelectorTab && this.contains(deviceSelectorTab)) {
        this.selectDeviceGroup(deviceSelectorTab);
        return;
      }

      const button = event.target.closest('[data-filter]');
      if (!button || !this.contains(button)) return;

      const group = button.dataset.filter;
      const value = button.dataset.value;
      this[group] = value;
      this.querySelectorAll(`[data-filter="${group}"]`).forEach((candidate) => {
        candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
      });
      this.render();
    });

    this.render();
  }

  selectDeviceGroup(tab) {
    const selectedGroup = tab.dataset.deviceSelectorTab;
    this.querySelectorAll('[data-device-selector-tab]').forEach((candidate) => {
      candidate.setAttribute('aria-pressed', candidate === tab ? 'true' : 'false');
    });
    this.querySelectorAll('[data-device-selector-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.deviceSelectorPanel !== selectedGroup;
    });
    const heading = this.querySelector('[data-device-selector-heading-live]');
    if (heading) heading.textContent = tab.dataset.deviceSelectorHeading;
  }

  render() {
    let visible = 0;

    this.items.forEach((item) => {
      const familyMatch = this.family === 'all' || item.dataset.family === this.family;

      const swatchContainer = item.querySelector('[data-product-swatches]');
      if (swatchContainer) {
        swatchContainer.hidden = swatchContainer.querySelectorAll('.iphone17-shop__swatch').length < 2;
      }

      item.hidden = !familyMatch;
      if (!item.hidden) visible += 1;
    });

    this.count.textContent = `${visible} ${visible === 1 ? 'product' : 'products'} for ${this.deviceLabel}`;
    this.empty.hidden = visible !== 0;
  }
}

if (!customElements.get('iphone17-device-shop')) {
  customElements.define('iphone17-device-shop', IPhone17DeviceShop);
}
